import { render } from 'solid-js/web';
import { PedalsPanel } from './PedalsPanel';
import type { Actor } from 'xstate';
import type { pedalMachine } from '../machines/pedalMachines';

export function mountPedals(
  mountEl: HTMLElement,
  sustainActor: Actor<typeof pedalMachine>,
  vibratoActor: Actor<typeof pedalMachine>,
): void {
  render(
    () => (
      <PedalsPanel
        onSustainDown={() => { sustainActor.send({ type: 'ACTIVATE' }); }}
        onSustainUp={() => { sustainActor.send({ type: 'DEACTIVATE' }); }}
        onVibratoDown={() => { vibratoActor.send({ type: 'ACTIVATE' }); }}
        onVibratoUp={() => { vibratoActor.send({ type: 'DEACTIVATE' }); }}
      />
    ),
    mountEl,
  );
}
